import { useTranslation } from 'react-i18next';
import styles from './Header.module.css';

export default function Header() {
  const { t } = useTranslation();

  return (
    <header className={styles.content}>
      <div className={styles.headerContainer}>
        <div className={styles.headerText}>
          <h1 className={styles.title}>{t('eligible.header.title')}</h1>
          <div className={styles.fullWidth}>
            <div className={styles.hr} />
          </div>
          <h3 className={styles.subTitle}>{t('eligible.header.subtitle')}</h3>
        </div>
      </div>
    </header>
  );
}
